import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { LIST_TEMPLATES_QUERY_KEY } from "./useListTemplates";
import type { TemplateIn, TemplateOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

type CreateTemplateResult = { body: TemplateOut; message?: string };

async function postTemplate(payload: TemplateIn): Promise<CreateTemplateResult> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = await instance.post(
    API_ROUTES.CREATE_DYNAMIC_BONUS_TEMPLATE,
    payload,
  );
  const envelope = bonusAdminEnvelope<TemplateOut>(response);
  if (!envelope.body) {
    throw new Error("Template creation returned no data");
  }
  return { body: envelope.body, message: envelope.message };
}

export const useCreateTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateTemplateResult, Error, TemplateIn>({
    mutationFn: postTemplate,
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: LIST_TEMPLATES_QUERY_KEY });
      message.success(result.message || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED);
    },
    onError: (error) => {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
    },
  });
};
